import { createFileRoute } from "@tanstack/react-router";

import { QueryConsoleErrorBoundary } from "@/features/search-ops/query-console-error-boundary";
import { QueryConsolePanel } from "@/features/search-ops/query-console-panel";

export const Route = createFileRoute("/_authenticated/search/query-console")({
  component: QueryConsoleRoute,
});

function QueryConsoleRoute() {
  return (
    <QueryConsoleErrorBoundary>
      <QueryConsolePanel />
    </QueryConsoleErrorBoundary>
  );
}
